import React, { useState, useEffect } from "react";
import BaseEmailComponent from "../BaseEmailComponent";
import { Form } from "react-bootstrap";

const OfferBlock = ({ id, data, onUpdate, styleSettings }) => {
  const [promoCode, setPromoCode] = useState(data?.promoCode || "");
  const [hasPromoCode, setHasPromoCode] = useState(!!data?.promoCode);

  // Update component state when data changes
  useEffect(() => {
    if (data) {
      setPromoCode(data.promoCode || "");
      setHasPromoCode(!!data.promoCode);
    }
  }, [data]);

  // Edit UI with forms
  const renderEditUI = ({ title, setTitle, description, setDescription, handleSaveChanges, styleSettings }) => {
    // Function to save all changes at once
    const saveAllChanges = () => {
      const additionalData = hasPromoCode ? { promoCode } : {};
      handleSaveChanges(title, description, additionalData);
    };

    return (
      <div className="p-3 rounded" style={{ backgroundColor: 'white' }}>
        <Form.Group className="mb-3">
          <Form.Label><strong>Offer Title</strong></Form.Label>
          <Form.Control
            type="text"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            onBlur={saveAllChanges}
            placeholder="Enter Offer Title"
          />
        </Form.Group>
        
        <Form.Group className="mb-3">
          <Form.Label><strong>Offer Description</strong></Form.Label>
          <Form.Control
            as="textarea"
            rows={4}
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            onBlur={saveAllChanges}
            placeholder="Enter Offer Description"
          />
        </Form.Group>
        
        <Form.Group className="mb-3">
          <Form.Check
            type="checkbox"
            id="hasPromoCodeCheckbox"
            label="Include Promo Code"
            checked={hasPromoCode}
            onChange={(e) => {
              setHasPromoCode(e.target.checked);
              if (!e.target.checked) {
                // If unchecked, remove promo code from data
                handleSaveChanges(title, description, { promoCode: null });
              }
            }}
            className="mb-2"
          />
          
          {hasPromoCode && (
            <Form.Control
              type="text"
              value={promoCode}
              onChange={(e) => setPromoCode(e.target.value)}
              onBlur={saveAllChanges}
              placeholder="Enter Promo Code"
            />
          )}
        </Form.Group>
      </div>
    );
  };

  // View UI for display mode
  const renderViewUI = ({ title, description, styleSettings }) => {
    const { primaryColor, secondaryColor, fontFamily } = styleSettings || {};

    return (
      <div className="offer-block py-3">
        <div className="text-center">
          <h2 style={{ 
            fontSize: "24px", 
            marginBottom: "16px",
            color: secondaryColor || "#a1894c",
            fontFamily,
            fontWeight: "bold"
          }}>
            {title}
          </h2>
          
          <p style={{ 
            fontFamily,
            color: primaryColor || "#333333",
            lineHeight: "1.5",
            marginBottom: hasPromoCode ? "20px" : "0"
          }}>
            {description}
          </p>
          
          {hasPromoCode && (
            <div 
              style={{
                backgroundColor: secondaryColor || "#a1894c",
                color: "#ffffff",
                padding: "12px 20px",
                borderRadius: "6px",
                display: "inline-block",
                fontWeight: "bold",
                letterSpacing: "1px",
                marginTop: "10px",
                fontFamily
              }}
            >
              {promoCode}
            </div>
          )}
        </div>
      </div>
    );
  };

  return (
    <BaseEmailComponent
      id={id}
      data={data}
      onUpdate={onUpdate}
      componentName="Special Offer"
      styleSettings={styleSettings}
      editUI={renderEditUI}
      viewUI={renderViewUI}
    />
  );
};

export default OfferBlock; 